// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/** Shared formatting helpers for the read-only proposal plan view. */

export const formatPlanCurrency = (amount: number, currency?: string): string => {
  try {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency: currency || 'EUR',
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return currency ? `${amount.toFixed(2)} ${currency}` : amount.toFixed(2);
  }
};

export const formatPercent = (value: number): string => `${value}%`;

/** "Year 1: 5% / Year 2: 3%" (or "NIL" for an empty/absent schedule). */
export const formatYearSchedule = (values?: number[]): string => {
  if (!values || values.length === 0) return 'NIL';
  return values.map((v, i) => `Year ${i + 1}: ${v}%`).join(' / ');
};
